module.exports = __webpack_public_path__ + "img/29_27.4092f658.png";